var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelivery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "carbon:delivery-parcel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.2687 5.929L13.3937 2.14775C13.2921 2.0919 13.1782 2.06261 13.0623 2.06261C12.9464 2.06261 12.8324 2.0919 12.7309 2.14775L5.85591 5.929C5.74812 5.98834 5.65823 6.07554 5.59563 6.18147C5.53303 6.2874 5.5 6.4082 5.5 6.53125C5.5 6.6543 5.53303 6.77509 5.59563 6.88102C5.65823 6.98696 5.74812 7.07415 5.85591 7.1335L12.3748 10.7188V18.0881L10.2875 16.94L9.62479 18.1438L12.7309 19.8522C12.8324 19.9082 12.9464 19.9376 13.0623 19.9376C13.1782 19.9376 13.2922 19.9082 13.3937 19.8522L20.2687 16.071C20.3765 16.0117 20.4664 15.9245 20.5291 15.8186C20.5917 15.7126 20.6248 15.5918 20.6248 15.4687V6.53125C20.6248 6.40818 20.5917 6.28737 20.5291 6.18143C20.4664 6.0755 20.3765 5.98832 20.2687 5.929ZM13.0623 3.53512L18.5107 6.53125L13.0623 9.52737L7.61385 6.53125L13.0623 3.53512ZM19.2498 15.0624L13.7498 18.0874V10.7181L19.2498 7.69312V15.0624Z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.875 11H1.375V9.625H6.875V11ZM8.25 16.5H2.75V15.125H8.25V16.5ZM9.625 13.75H4.125V12.375H9.625V13.75Z",
    fill: "#555555"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.4aaffe9809d4eca84b1870b92f1f2cc3.svg";
export { ForwardRef as ReactComponent };